import React from 'react';
import Helmet from 'react-helmet';

import * as LeftSideBar from '../../../common/organisms/LeftSideBar';
import * as TopBar from '../../../common/organisms/TopBar';
import KDSLeftSideBar from '../../KDSLeftSideBar/KDSLeftSideBar';
import KDSTopBar from '../../KDSTopBar/KDSTopbar';
import ContentWrapper from './ContentWrapper';

type AppPropsProps = {
	pageTitle?: string;
	titleTemplate?: string;
	content?: string;
	children: React.ReactNode;
};

const AppTemplate = ({
	titleTemplate,
	pageTitle,
	content,
	children,
}: AppPropsProps) => {
	return (
		<div className="App" id="wrapper">
			<Helmet titleTemplate={titleTemplate} defaultTitle={pageTitle}>
				<meta name="description" content={content} />
			</Helmet>

			{children}
		</div>
	);
};

AppTemplate.LeftSideBar = LeftSideBar.LeftSideBar;
AppTemplate.KDSLeftSideBar = KDSLeftSideBar;
AppTemplate.ContentWrapper = ContentWrapper;
AppTemplate.TopBar = TopBar.TopBar;
AppTemplate.KDSTopBar = KDSTopBar;

export default AppTemplate;
